function writeJsonToLocalStorage<T>(key: string, value: T) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(e, `error writing ${key} to local storage`);
  }
}

export default writeJsonToLocalStorage;
